import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/zengdai/Workspace/vimwiki/Projects/Blogger/blogv3/src/components/posts-layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "http://www.vim.org/"
      }}>{`Vim`}</a>{` is as powerful as your power armor but can be extremely lighter! I believe you click in to learn more about it. But here we don't talk much about `}<a parentName="p" {...{
        "href": "https://github.com/daizeng1984/dotfiles/blob/master/neovim/nvim/config/plugins.vimrc"
      }}>{`plugins`}</a>{`. Just some tips I found along daily use of vim ...`}</p>
    <h2>{`Vim Ads`}</h2>
    <p>{`Sorry before we jump in, here's the ads 😄.`}</p>
    <figure {...{
      "className": "gatsby-resp-image-figure",
      "style": {
        "position": "relative",
        "display": "block",
        "marginLeft": "auto",
        "marginRight": "auto",
        "width": "40%",
        "textAlign": "center",
        "minWidth": "7rem",
        "backgroundColor": "rgb(255, 255, 255)",
        "border": "1px solid rgb(222, 226, 230)",
        "maxWidth": "600px"
      }
    }}>{`
    `}<span parentName="figure" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "600px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/86d5bcf69612d038b66243e52c5fb8b6/b9962/vim-ads.jpg",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "148.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAeABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUBAwQG/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQAC/9oADAMBAAIQAxAAAAGu7XKLhkBOZPpxtmc+V//EABsQAAIDAQEBAAAAAAAAAAAAAAECAAMRExQx/9oACAEBAAEFAuQnJIKllShhYE1lClRtdvxn0pbk9bQ2nf/EABkRAAIDAQAAAAAAAAAAAAAAAAABAhARIf/aAAgBAwEBPwHIqkcP/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERECL/2gAIAQIBAT8Brx06P//EAB4QAAIDAAEFAAAAAAAAAAAAAAABAhEhMRASQVGB/9oACAEBAAY/Akkex4RlfCpi3tKSI5tFR8F8ivTFFfOn/8QAHRAAAwEBAAIDAAAAAAAAAAAAAAERITFBUWGh4f/aAAgBAQABPyFU5Ys9E8dZlCajmqmvrgEB9nSQCRccEjRlXdd+CUidLo2jOPA9hP5yh//aAAwDAQACAAMAAAAQEzp8/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oACAEDAQE/EA25rAQCyf/EABgRAQEBAQEAAAAAAAAAAAAAAAEAESFh/9oACAECAQE/EFebhK2ke7//xAAgEAEAAgEDBQEAAAAAAAAAAAABABEhMUFRYXGhscGR/9oACAEBAAE/ELQCkVreir3l2wqigA49ko4nOHYX5mLiwOarfeKwawS3gQCFGC6+wOliTppfyJW2hxtdVL0+wQEDAKY/zlqD3pIjBHi3tmkIdkfhP//Z')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="a" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Vim Today!",
            "title": "Vim Today!",
            "src": "/static/86d5bcf69612d038b66243e52c5fb8b6/b4294/vim-ads.jpg",
            "srcSet": ["/static/86d5bcf69612d038b66243e52c5fb8b6/75985/vim-ads.jpg 150w", "/static/86d5bcf69612d038b66243e52c5fb8b6/f93b5/vim-ads.jpg 300w", "/static/86d5bcf69612d038b66243e52c5fb8b6/b4294/vim-ads.jpg 600w", "/static/86d5bcf69612d038b66243e52c5fb8b6/8e1fc/vim-ads.jpg 900w", "/static/86d5bcf69612d038b66243e52c5fb8b6/e5166/vim-ads.jpg 1200w", "/static/86d5bcf69612d038b66243e52c5fb8b6/b9962/vim-ads.jpg 1334w"],
            "sizes": "(max-width: 600px) 100vw, 600px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
        "className": "gatsby-resp-image-figcaption"
      }}>{`Vim Today!`}</figcaption>{`
  `}</figure>
    <h2>{`Tips`}</h2>
    <ul>
      <li parentName="ul">{`Remap Capslock: For a vim user, capslock can be nightmare. In mac you could easily remap it with `}<a parentName="li" {...{
          "href": "https://pqrs.org/osx/karabiner/"
        }}>{`Karabiner`}</a>{` to something like `}<kbd>{`Esc`}</kbd>{`. In my dotfiles configuration, I remapped it to `}<kbd>{`F10`}</kbd>{` and make it a prefix key for tmux.`}</li>
      <li parentName="ul">{`Selection: `}<kbd>{`v`}</kbd>{` `}<kbd>{`i`}</kbd>{` `}<kbd>{`t`}</kbd>{` means select within tag. You can visual select in `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`t`}</code>{`ag or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`b`}</code>{`lock or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`w`}</code>{`ord. Also you should arm with Pope's `}<a parentName="li" {...{
          "href": "https://github.com/tpope/vim-surround"
        }}>{`surround plugin`}</a>{` (you need some practices to master power of surround). Similarly working for `}<kbd>{`y`}</kbd>{` `}<kbd>{`d`}</kbd>{` etc. as well.`}</li>
      <li parentName="ul">{`Numbers: when you have some text and number editing e.g. adding increasing number for each line. You could do this in command  `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:put =range(1,10, 2)`}</code></li>
      <li parentName="ul">{`Tabs: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:retab`}</code>{` will just remove every tabs into spaces (nice 😌)`}</li>
      <li parentName="ul">{`Jump between tags: you could visually select around tag `}<kbd>{`v`}</kbd>{`+`}<kbd>{`a`}</kbd>{`+`}<kbd>{`t`}</kbd>{` and use `}<kbd>{`o`}</kbd>{` to switch.`}</li>
      <li parentName="ul">{`Global variable: sometimes, you'd like to see the tab, and strange non-printable chars in your vim you could do `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:set list`}</code>{`; for some files, you'd like to know the file format by `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:set ff?`}</code>{` and yes this is actually a command to see and set global variables in vim! `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:set varname`}</code>{` or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:set varname?`}</code></li>
      <li parentName="ul">{`Macro: `}<kbd>{`q`}</kbd>{` and then a register name to record it. `}<kbd>{`@`}</kbd>{` or `}<kbd>{`shift`}</kbd>{`+`}<kbd>{`2`}</kbd>{` to apply it. It's simple but extremely useful. There are some complicate macro tricks to do numbers, or incrementally, but since I don't usually use them and they just overflow, out of my memory :laughing:...`}</li>
      <li parentName="ul">{`Bookmark: `}<kbd>{`m`}</kbd>{` + a char to add and `}<kbd>{`'`}</kbd>{` + the char to jump there and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:marks`}</code>{` to show all`}</li>
      <li parentName="ul">{`Mysteriuos `}<kbd>{`g`}</kbd>{`: `}<kbd>{`g`}</kbd><kbd>{`f`}</kbd>{` to open the file under cursor and `}<kbd>{`g`}</kbd><kbd>{`x`}</kbd>{` to open it in xwindow system... `}<kbd>{`ctrl`}</kbd>{`+`}<kbd>{`g`}</kbd>{` to show file path information`}</li>
      <li parentName="ul">{`History of command: `}<kbd>{`q:`}</kbd>{` and for macros we have `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:registers`}</code>{`/`}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:reg`}</code>{` or `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:echo @a`}</code>{` for a single register `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`a`}</code></li>
      <li parentName="ul">{`Window zoom fullscreen: `}<kbd>{`ctrl`}</kbd>{`+`}<kbd>{`w`}</kbd>{`, `}<kbd>{`o`}</kbd></li>
      <li parentName="ul">
        <kbd>ctrl</kbd>+<kbd>r</kbd> in Insert Mode and then <kbd>=</kbd> allows you do math or something more powerful e.g. `=range(1,10)`!
      </li>
      <li parentName="ul">{`% is currentbuffer in ex command e.g. `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:Remove %`}</code>{`.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`'<`}</code>{` and `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`'>`}</code>{` are start and end line of visual block. Therefore, for example, to replace extra spaces in your selection, you can do vim's `}<a parentName="li" {...{
          "href": "http://vimregex.com/"
        }}>{`Regular Expression`}</a>{`: `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`'<'>s/\\s\\s\\+/ /g`}</code>{`.`}</li>
      <li parentName="ul">{`reverse all lines `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`:g/^/m0`}</code>{` which actually takes reg exp matched lines and then move them to line 0.`}</li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`jumplist`}</code>{`: jump to last edit/change location `}<kbd>{`g`}</kbd>{`+`}<kbd>{`;`}</kbd>{` and `}<kbd>{`g`}</kbd>{`+`}<kbd>{`,`}</kbd></li>
      <li parentName="ul"><code parentName="li" {...{
          "className": "language-text"
        }}>{`:vert diffs <tab>`}</code>{` to simply vsplit buffer to diff`}</li>
    </ul>
    <h2>{`Reference`}</h2>
    <p>{`I found some really really nice presentation that worth a look: Erik Falor's `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=MquaityA1SM"
      }}>{`"From Vim Muggle to Wizard in 10 Easy Steps"`}</a>{`; when you get totally naked in an alien linux server, watch `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=XA2WjJbmmoM&t=907s"
      }}>{`this`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      